import { C } from "../data/content";

const defaultItems = [
  C.duration, `${C.moduleCount} CORE MODULES`, "LIVE Q&A INCLUDED",
  "FL, TX & PA COVERAGE", "NO COST TO ATTEND", "VA HOME LOAN QUALIFICATION SPECIALISTS",
];

const Track = ({ items }) => (
  <div className="marquee-track py-4">
    {items.map((it, i) => (
      <span key={i} className="mono text-[11px] text-white/40 flex items-center">
        <span className="px-6">{it}</span>
        <span className="text-[var(--accent)]">◆</span>
      </span>
    ))}
  </div>
);

export const Ticker = ({ items = defaultItems }) => (
  <section className="marquee" data-testid="proof-ticker">
    <Track items={items} /><Track items={items} />
  </section>
);
